<ng-container *ngIf="product?.active">
    <div
        class="mat-cell text-muted state-label mt-3"
        *ngIf="
            product.amount > product.stock &&
            product?.in_stock &&
            product.can_buy > 0 &&
            product.stock > 0
        "
    >
        <span *ngIf="lang == 'en'"
            >Only {{ product.stock }} available in stock</span
        >
        <span *ngIf="lang == 'ar'">يوجد {{ product.stock }} منتج متاح فقط</span>
        <span></span>
    </div>

    <div
        class="mat-cell text-muted state-label outofstock"
        *ngIf="
            (!product?.in_stock || product.stock == 0) &&
            (product.can_buy > 0 || product.can_buy == null) &&
            product.stock != null
        "
    >
        {{ "orders.outOfStock" | translate }}
    </div>

    <div class="mat-cell text-muted state-label" *ngIf="product?.can_buy == 0">
        {{ "cart.cantBuy" | translate }}
    </div>

    <div
        class="mat-cell text-muted state-label mt-3"
        *ngIf="product.can_buy > 0 && product.can_buy < product.amount"
    >
        <span *ngIf="lang == 'en'"
            >you can only buy {{ product.can_buy }} of this item</span
        >
        <span *ngIf="lang == 'ar'"
            >يمكنك شراء {{ product.can_buy }} فقط من هذا المنتج</span
        >
        <span></span>
    </div>

    <div class="mat-cell text-muted state-label" *ngIf="product?.preorder">
        {{ "productDetails.preorder" | translate }}
    </div>

    <div
        class="mat-cell text-muted state-label"
        *ngIf="product?.available_soon"
    >
        {{ "productDetails.availableSoon" | translate }}
    </div>
</ng-container>

<ng-container *ngIf="!product?.active || product?.stock == null">
    <div class="mat-cell text-muted state-label">
        {{ "orders.notAvailable" | translate }}
    </div>
</ng-container>
